(() => {
  const carousel = document.querySelector('[data-sxt-hero-carousel]');
  if (carousel) {
    const slides = [...carousel.querySelectorAll('[data-sxt-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-sxt-hero-dot]')];
    const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const selected = i === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        slide.tabIndex = selected ? 0 : -1;
        dots[i]?.classList.toggle('is-active', selected);
      });
    };
    const play = () => {
      clearInterval(timer);
      if (motionPreference.matches) return;
      timer = setInterval(() => show(active + 1), 3200);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); play(); }));
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', play);
    motionPreference.addEventListener?.('change', play);
    if (slides.length > 1) play();
  }

  const discountNodes = document.querySelectorAll('[data-sxt-max-discount]');
  if (!discountNodes.length) return;
  const cached = Number(sessionStorage.getItem('sxtMaxDiscountV6'));
  if (cached > 0) {
    discountNodes.forEach((node) => { node.textContent = cached; });
    return;
  }
  const calculate = async () => {
    let maximum = Number(discountNodes[0].textContent) || 0;
    for (let page = 1; page <= 6; page += 1) {
      const response = await fetch(`/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
      if (!response.ok) break;
      const { products = [] } = await response.json();
      products.forEach((product) => product.variants.forEach((variant) => {
        const current = Number(variant.price);
        const compare = Number(variant.compare_at_price);
        if (compare > current && current > 0) maximum = Math.max(maximum, Math.round(((compare - current) / compare) * 100));
      }));
      if (products.length < 250) break;
    }
    if (maximum > 0) {
      sessionStorage.setItem('sxtMaxDiscountV6', String(maximum));
      discountNodes.forEach((node) => { node.textContent = maximum; });
    }
  };
  const runCalculation = () => calculate().catch(() => {});
  if ('requestIdleCallback' in window) requestIdleCallback(runCalculation, { timeout: 2500 });
  else setTimeout(runCalculation, 1200);
})();
